import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { GET_ENVIRONMENT_CONFIGS } from '../constants/api-endpoints';

export interface EnvironmentConfigRequest {
  configKey?: string;
  configKeys?: string[];
  showUuid?: string;
}

export interface EnvironmentConfig {
  key?: string;
  value?: string;
}

@Injectable({ providedIn: 'root' })
export class EncryptionService {
  private readonly http = inject(HttpClient);

  getEnvironmentConfigs(request: EnvironmentConfigRequest = {}): Observable<EnvironmentConfig[]> {
    return this.http
      .post<unknown>(GET_ENVIRONMENT_CONFIGS, request)
      .pipe(map((response) => this.toConfigList(response)));
  }

  private toConfigList(response: unknown): EnvironmentConfig[] {
    const body = response as { data?: unknown } | null;
    const data = body && typeof body === 'object' && 'data' in body ? body.data : response;

    let rows: unknown[] = [];
    if (Array.isArray(data)) {
      rows = data;
    } else if (data && typeof data === 'object') {
      rows = [data];
    }

    return (rows as Array<Record<string, unknown>>)
      .filter((row) => row && typeof row === 'object')
      .map((row) => ({
        key: this.read(row, 'configKey') ?? this.read(row, 'key') ?? this.read(row, 'name'),
        value: this.read(row, 'configValue') ?? this.read(row, 'value')
      }));
  }

  private read(row: Record<string, unknown>, field: string): string | undefined {
    const match = Object.keys(row).find((k) => k.toLowerCase() === field.toLowerCase());
    const value = match ? row[match] : undefined;
    return typeof value === 'string' ? value : undefined;
  }
}
